import { render, staticRenderFns } from "./Subjects.vue?vue&type=template&id=0f9f6d26&scoped=true"
import script from "./Subjects.vue?vue&type=script&lang=js"
export * from "./Subjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9f6d26",
  null
  
)

export default component.exports